module.exports = __webpack_public_path__ + "static/media/token8.4af1833b.png";